import React from 'react';
import { Field, ErrorMessage, getIn } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback, Button } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';
import { DataTambahan } from './DataTambahan';
import { BeneficialOwner } from './BeneficialOwner';

export const Page4Job = ({ errors, touched, values, state, handleChange, handleBlur, onValueChange, occupations, onHaveAccountsInOtherBank, onOccupationChange, onBusinessFieldChange, onPositionChange, positions, props, setFieldValue, onTINSSNMandatoryChange, onPenghasilanPerTahunChange, onFundSourceChange,
    imageChange,
    onCorrespondenceProvinceChange, toggleModalKodeArea }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Data Pekerjaan dan Profil Risiko</legend>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Pekerjaan</Label>
                        <Field component="select" name="OccupationId"
                            className={errors.OccupationId && touched.OccupationId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onOccupationChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {occupations.map((occupation, i) =>
                                <option key={i} value={occupation.Id}>{occupation.Description}</option>
                            )}
                        </Field>
                        {errors.OccupationId && touched.OccupationId ? (
                            <FormFeedback>{errors.OccupationId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

                {(values.OccupationId === "12") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Pekerjaan Lainnya</Label>
                            <Input tag={Field} type="text" name="OccupationOthers" bsSize="sm" disabled={values.OccupationId !== "12"}
                                className={errors.OccupationOthers && touched.OccupationOthers ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            />
                            {errors.OccupationOthers && touched.OccupationOthers ? (
                                <FormFeedback>{errors.OccupationOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Posisi<span className="text-danger">*</span></Label>
                        <Field component="select" name="PositionId"
                            className={errors.PositionId && touched.PositionId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onPositionChange(e, values.OccupationId, setFieldValue, values)}
                        >
                            <option value="">-- Pilih --</option>
                            {positions.sort((a, b) => b.Id - a.Id).map((position, i) =>
                                <option key={i} value={position.Id}>{position.Description}</option>
                            )}
                        </Field>
                        {errors.PositionId && touched.PositionId ? (
                            <FormFeedback>{errors.PositionId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {(values.PositionId == "41") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Posisi Lainnya</Label>
                            <Input tag={Field} type="text" name="PositionOthers" bsSize="sm" disabled={values.PositionId != "41"}
                                className={errors.PositionOthers && touched.PositionOthers ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            />
                            {errors.PositionOthers && touched.PositionOthers ? (
                                <FormFeedback>{errors.PositionOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Bidang Usaha<span className="text-danger">*</span></Label>
                        <Field component="select" name="BusinessFieldId"
                            className={errors.BusinessFieldId && touched.BusinessFieldId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onBusinessFieldChange(e, setFieldValue, values)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.businessFields.map((businessField, i) =>
                                <option key={i} value={businessField.Id}>{businessField.Description}</option>
                            )}
                        </Field>
                        {errors.BusinessFieldId && touched.BusinessFieldId ? (
                            <FormFeedback>{errors.BusinessFieldId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {(values.BusinessFieldId == "25") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Bidang Usaha Lainnya</Label>
                            <Input tag={Field} type="text" name="BusinessFieldOthers" bsSize="sm" disabled={values.BusinessFieldId != "25"}
                                className={errors.BusinessFieldOthers && touched.BusinessFieldOthers ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'} />
                            {errors.BusinessFieldOthers && touched.BusinessFieldOthers ? (
                                <FormFeedback>{errors.BusinessFieldOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Penghasilan / Tahun<span className="text-danger">*</span></Label>
                        <Field component="select" name="IncomePerAnnumId"
                            className={errors.IncomePerAnnumId && touched.IncomePerAnnumId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onPenghasilanPerTahunChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomePerAnnums.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.IncomePerAnnumId && touched.IncomePerAnnumId ? (
                            <FormFeedback>{errors.IncomePerAnnumId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Penghasilan<span className="text-danger">*</span></Label>
                        <Field component="select" name="FundSourceId"
                            className={errors.FundSourceId && touched.FundSourceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onFundSourceChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.fundSources.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.FundSourceId && touched.FundSourceId ? (
                            <FormFeedback>{errors.FundSourceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {values.FundSourceId === "1" ? (
                    <Col md="4">
                        <FormGroup>
                            <Label>Sumber Penghasilan Lainnya</Label>
                            <Input tag={Field} type="text" name="FundSourceOthers" bsSize="sm" disabled={values.FundSourceId !== "1"}
                                className={errors.FundSourceOthers && touched.FundSourceOthers ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            ></Input>
                            {errors.FundSourceOthers && touched.FundSourceOthers ? (
                                <FormFeedback>{errors.FundSourceOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                ) : null}
            </Row>
            <Row>
                <Col md="8">
                    <FormGroup>
                        <Label>Nama Tempat Bekerja/Usaha/Sekolah<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="CompanyName" bsSize="sm" maxLength="30"

                            invalid={!!(getIn(errors, 'CompanyName') && getIn(touched, 'CompanyName'))}
                        />
                        <ErrorMessage
                            name="CompanyName"
                            component="div"
                            className="invalid-feedback"
                        />
                        {/*{errors.CompanyName && touched.CompanyName ? (*/}
                        {/*    <FormFeedback>{errors.CompanyName}</FormFeedback>*/}
                        {/*) : null}*/}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Lama Bekerja/Usaha (tahun)</Label>
                        <Input tag={Field} type="number" name="LengthOfWork" bsSize="sm"
                            invalid={errors.LengthOfWork && touched.LengthOfWork} />
                        {errors.LengthOfWork && touched.LengthOfWork ? (
                            <FormFeedback>{errors.LengthOfWork}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat Tempat Bekerja/Usaha/Sekolah<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="CompanyAddress" bsSize="sm"
                            invalid={errors.CompanyAddress && touched.CompanyAddress} maxLength={30} />
                        {errors.CompanyAddress && touched.CompanyAddress ? (
                            <FormFeedback>{errors.CompanyAddress}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="10" xs="8">
                    <Label>Kota<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="text" name="CompanyAddressCity" maxLength="30" bsSize="sm"
                        invalid={errors.CompanyAddressCity && touched.CompanyAddressCity} />
                    {errors.CompanyAddressCity && touched.CompanyAddressCity ? (
                        <FormFeedback>{errors.CompanyAddressCity}</FormFeedback>
                    ) : null}
                </Col>
                <Col md="2" xs="4">
                    <FormGroup>
                        <Label>Kode Pos<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="CompanyPostalCode" maxLength="5" pattern="[0-9]*" bsSize="sm"
                            invalid={errors.CompanyPostalCode && touched.CompanyPostalCode} />
                        {errors.CompanyPostalCode && touched.CompanyPostalCode ? (
                            <FormFeedback>{errors.CompanyPostalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="2" xs="4">
                    <FormGroup>
                        <Label>Kode Area Telp<span className="text-danger">*</span></Label>
                        <div className="input-group">
                            <Input tag={Field} type="tel" name="CompanyPhoneAreaCode" maxLength="4" pattern="[0-9]*" bsSize="sm"
                                invalid={errors.CompanyPhoneAreaCode && touched.CompanyPhoneAreaCode} placeholder="Cth. 021" />
                            <Button className='btn btn-sm input-group-append' type="button" onClick={() => toggleModalKodeArea('CompanyPhoneAreaCode')} ><i className="bi bi-search"></i></Button>
                        </div>
                        {errors.CompanyPhoneAreaCode && touched.CompanyPhoneAreaCode ? (
                            <FormFeedback>{errors.CompanyPhoneAreaCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="8">
                    <FormGroup>
                        <Label>No Telepon Tempat Bekerja/Usaha/Sekolah<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="number" name="CompanyPhoneNumber" bsSize="sm"
                            invalid={errors.CompanyPhoneNumber && touched.CompanyPhoneNumber} />
                        {errors.CompanyPhoneNumber && touched.CompanyPhoneNumber ? (
                            <FormFeedback>{errors.CompanyPhoneNumber}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Lama Tinggal Di Alamat Terakhir (Bulan - Tahun)<span className="text-danger">*</span></Label>
                        <Field component="input" name="LongStayAtLastAddressYear" type="month"
                            className={errors.LongStayAtLastAddressYear && touched.LongStayAtLastAddressYear ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                        </Field>
                        {errors.LongStayAtLastAddressYear && touched.LongStayAtLastAddressYear ? (
                            <FormFeedback>{errors.LongStayAtLastAddressYear}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Tujuan Investasi<span className="text-danger">*</span></Label>
                        <Field component="select" name="InvestmentObjectiveId"
                            className={errors.InvestmentObjectiveId && touched.InvestmentObjectiveId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.investmentObjectives.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.InvestmentObjectiveId && touched.InvestmentObjectiveId ? (
                            <FormFeedback>{errors.InvestmentObjectiveId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>Wajib FATCA<span className="text-danger">*</span></Label>
                        <Row>
                            <Col xs="6">
                                <div className="custom-control custom-radio">
                                    <Input type="radio" className="custom-control-input" id="FATCAMandatory1"
                                        onChange={handleChange} onBlur={handleBlur}
                                        checked={values.FATCAMandatory === "1"}
                                        name="FATCAMandatory" value="1" />
                                    <label className="custom-control-label" htmlFor="FATCAMandatory1">Ya</label>
                                </div>
                            </Col>
                            <Col xs="6">
                                <div className="custom-control custom-radio">
                                    <Input type="radio" className="custom-control-input" checked={values.FATCAMandatory === "2"}
                                        onChange={handleChange} onBlur={handleBlur}
                                        id="FATCAMandatory2" name="FATCAMandatory" value="2" />
                                    <label className="custom-control-label" htmlFor="FATCAMandatory2">Tidak</label>
                                </div>
                            </Col>
                        </Row>
                        {errors.FATCAMandatory && touched.FATCAMandatory ? (
                            <FormFeedback>{errors.FATCAMandatory}</FormFeedback>
                        ) : null}
                        <small id="emailHelp" className="form-text text-muted">Hanya diisi apabila memiliki wajib pajak di negara lain</small>
                    </FormGroup>
                </Col>
                {values.FATCAMandatory === "1" ?
                    <Col md="4">
                        <FormGroup>
                            <Label>TIN/SSN</Label>
                            {values.FATCAMandatory === "2"}
                            <Input tag={Field} name="TINSSN" bsSize="sm" type="number" invalid={errors.TINSSN && touched.TINSSN}
                                disabled={values.FATCAMandatory === "2"}
                            />
                            {errors.TINSSN && touched.TINSSN ? (
                                <FormFeedback>{errors.TINSSN}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
                <Col md="6">
                    <FormGroup>
                        <Label>Wajib Pajak Negara Lain<span className="text-danger">*</span></Label>
                        <Row>
                            <Col xs="6">
                                <div className="custom-control custom-radio">
                                    <Input type="radio" className="custom-control-input" id="TaxpayerOtherContry1"
                                        onChange={handleChange} onBlur={handleBlur}
                                        checked={values.TaxpayerOtherContry === "1"}
                                        name="TaxpayerOtherContry" value="1" />
                                    <label className="custom-control-label" htmlFor="TaxpayerOtherContry1">Ya</label>
                                </div>
                            </Col>
                            <Col xs="6">
                                <div className="custom-control custom-radio">
                                    <Input type="radio" className="custom-control-input" checked={values.TaxpayerOtherContry === "2"}
                                        onChange={handleChange} onBlur={handleBlur}
                                        id="TaxpayerOtherContry2" name="TaxpayerOtherContry" value="2" />
                                    <label className="custom-control-label" htmlFor="TaxpayerOtherContry2">Tidak</label>
                                </div>
                            </Col>
                        </Row>
                        {errors.TaxpayerOtherContry && touched.TaxpayerOtherContry ? (
                            <FormFeedback>{errors.TaxpayerOtherContry}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Perkiraan Transaksi Efek Harian<span className="text-danger">*</span></Label>
                        <Field component="select" name="DailyNormalTransactionId"

                            className={errors.DailyNormalTransactionId && touched.DailyNormalTransactionId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/* <option value="">-- Pilih --</option> */}
                            {dataSeed.dailyNormalTransactions.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col sm="12" xs="12">
                    <FormGroup>
                        <Label>Nama Kontak Darurat<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="text" name="EmergencyContactName" bsSize="sm"
                            invalid={errors.EmergencyContactName && touched.EmergencyContactName} />
                        {errors.EmergencyContactName && touched.EmergencyContactName ? (
                            <FormFeedback>{errors.EmergencyContactName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col sm="6" xs="6">
                    <FormGroup>
                        <Label>Nomor Telepon<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="number" name="EmergencyContactPhoneNumber" bsSize="sm"
                            invalid={errors.EmergencyContactPhoneNumber && touched.EmergencyContactPhoneNumber} />
                        {errors.EmergencyContactPhoneNumber && touched.EmergencyContactPhoneNumber ? (
                            <FormFeedback>{errors.EmergencyContactPhoneNumber}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col sm="6" xs="6">
                    <FormGroup>
                        <Label>Hubungan<span className="text-danger">*</span></Label>
                        <Field component="select" name="EmergencyContactRelation"
                            className={errors.EmergencyContactRelation && touched.EmergencyContactRelation ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="Istri/Suami">Istri/Suami</option>
                            <option value="Orang Tua">Orang Tua</option>
                            <option value="Anak">Anak</option>
                            <option value="Saudara Kandung">Saudara Kandung</option>
                            <option value="kerabat">Kerabat</option>
                        </Field>
                        {errors.EmergencyContactRelation && touched.EmergencyContactRelation ? (
                            <FormFeedback>{errors.EmergencyContactRelation}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>

        </FormGroup>
        <FormGroup>
            {/*    <legend>Alamat Korespondensi</legend>*/}
            {/*<Row>*/}
            {/*    <Col md="4">*/}
            {/*        <FormGroup>*/}
            {/*            <Label>Alamat Korespondensi<span className="text-danger">*</span></Label>*/}
            {/*            <Field component="select" name="CorrespondenceAddress"*/}
            {/*                className={errors.CorrespondenceAddress && touched.CorrespondenceAddress ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}*/}
            {/*            >*/}
            {/*                <option value="">-- Pilih --</option>*/}
            {/*                <option value="1">Sesuai Alamat Identitas</option>*/}
            {/*                <option value="2">Alamat Tempat Tinggal</option>*/}
            {/*                */}{/* <option value="3">Alamat Kantor</option>*/}{/*
            */}{/*                    <option value="4">Alamat Lainnya</option> */}
            {/*            </Field>*/}
            {/*            {errors.CorrespondenceAddress && touched.CorrespondenceAddress ? (*/}
            {/*                <FormFeedback>{errors.CorrespondenceAddress}</FormFeedback>*/}
            {/*            ) : null}*/}
            {/*        </FormGroup>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row hidden={values.CorrespondenceAddress !== "4"}>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="CorrespondenceAddressLine1" bsSize="sm" invalid={errors.CorrespondenceAddressLine1 && touched.CorrespondenceAddressLine1} maxLength={50} />
                        {errors.CorrespondenceAddressLine1 && touched.CorrespondenceAddressLine1 ? (
                            <FormFeedback>{errors.CorrespondenceAddressLine1}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row hidden={values.CorrespondenceAddress !== "4"}>
                <Col md="4">
                    <FormGroup>
                        <Label>Negara<span className="text-danger">*</span></Label>
                        <Field component="select" name="CorrespondenceAddressCountry"
                            className={errors.CorrespondenceAddressCountry && touched.CorrespondenceAddressCountry ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="ID">Indonesia</option>
                        </Field>
                        {errors.CorrespondenceAddressCountry && touched.CorrespondenceAddressCountry ? (
                            <FormFeedback>{errors.CorrespondenceAddressCountry}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Provinsi<span className="text-danger">*</span> </Label>
                        <Field component="select" name="CorrespondenceAddressprovinceId"
                            className={errors.CorrespondenceAddressprovinceId && touched.CorrespondenceAddressprovinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onCorrespondenceProvinceChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.provinces.map((province, i) =>
                                <option key={i} value={province.Id}>{province.Name}</option>
                            )}
                        </Field>
                        {errors.CorrespondenceAddressprovinceId && touched.CorrespondenceAddressprovinceId ? (
                            <FormFeedback>{errors.CorrespondenceAddressprovinceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>City<span className="text-danger">*</span></Label>
                        <Field component="select" name="CorrespondenceAddressCityId"
                            className={errors.CorrespondenceAddressCityId && touched.CorrespondenceAddressCityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {props.correspondenceCities ? props.correspondenceCities.map((city, i) =>
                                <option key={i} value={city.Id}>{city.Name}</option>
                            ) : null}
                        </Field>
                        {errors.CorrespondenceAddressCityId && touched.CorrespondenceAddressCityId ? (
                            <FormFeedback>{errors.CorrespondenceAddressCityId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row hidden={values.CorrespondenceAddress !== "4"}>
                <Col md="2">
                    <FormGroup>
                        <Label>Kode Pos<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="tel" name="CorrespondenceAddressPostalCode" bsSize="sm" maxLength="5"
                            invalid={errors.CorrespondenceAddressPostalCode && touched.CorrespondenceAddressPostalCode}
                        />
                        {errors.CorrespondenceAddressPostalCode && touched.CorrespondenceAddressPostalCode ? (
                            <FormFeedback>{errors.CorrespondenceAddressPostalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>

        {values.BeneficialOwner &&
            <FormGroup tag="fieldset" hidden={!(values.OccupationId === "3" || values.OccupationId === "7")}>
                <BeneficialOwner
                    errors={errors}
                    props={props}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    onValueChange={onValueChange}
                    onOccupationChange={onOccupationChange}
                    onPositionChange={onPositionChange}
                    onBusinessFieldChange={onBusinessFieldChange}
                    occupations={occupations}
                    imageChange={imageChange}
                    onBusinessFieldChange={onBusinessFieldChange}
                    values={values} />

            </FormGroup>
        }
        <FormGroup tag="fieldset" hidden={!(values.OccupationId === "3" || values.OccupationId === "7")}>
            <legend>Data Pasangan / Orang Tua</legend>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Nama Sesuai Identitas</Label>
                        <Input tag={Field} type="text" name="PartnerOrParentName" maxLength="30" bsSize="sm"
                            invalid={errors.PartnerOrParentName && touched.PartnerOrParentName} />
                        {errors.PartnerOrParentName && touched.PartnerOrParentName ? (
                            <FormFeedback>{errors.PartnerOrParentName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Hubungan</Label>
                        <Field component="select" name="PartnerOrParentRelationshipId"
                            className={errors.PartnerOrParentRelationshipId && touched.PartnerOrParentRelationshipId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="1">Suami</option>
                            <option value="2">Istri</option>
                            <option value="3">Ayah</option>
                            <option value="4">Ibu</option>
                            <option value="5">Lainnya</option>
                        </Field>
                        {errors.PartnerOrParentRelationshipId && touched.PartnerOrParentRelationshipId ? (
                            <FormFeedback>{errors.PartnerOrParentRelationshipId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {values.PartnerOrParentRelationshipId == '5' ?
                    <Col md="3">
                        <FormGroup>
                            <Label>Hubungan Lainnya</Label>
                            <Input tag={Field} type="text" name="PartnerOrParentRelationshipOthers" maxLength="30" bsSize="sm"
                                disabled={values.PartnerOrParentRelationshipId !== "5"}
                                invalid={errors.PartnerOrParentRelationshipOthers && touched.PartnerOrParentRelationshipOthers} />
                            {errors.PartnerOrParentRelationshipOthers && touched.PartnerOrParentRelationshipOthers ? (
                                <FormFeedback>{errors.PartnerOrParentRelationshipOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col> : null}
            </Row>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Nomor KTP</Label>
                        <Input tag={Field} type="text" name="PartnerOrParentIdentityNumber" maxLength="30" bsSize="sm"
                            invalid={errors.PartnerOrParentIdentityNumber && touched.PartnerOrParentIdentityNumber} />
                        {errors.PartnerOrParentIdentityNumber && touched.PartnerOrParentIdentityNumber ? (
                            <FormFeedback>{errors.PartnerOrParentIdentityNumber}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Pekerjaan</Label>
                        <Field component="select" name="PartnerOrParentJobId"
                            className={errors.PartnerOrParentJobId && touched.PartnerOrParentJobId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onOccupationChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {occupations
                                .filter(occupation => !occupation.Description.toLowerCase().includes('ibu rumah tangga') && !occupation.Description.toLowerCase().includes('pelajar/mahasiswa'))
                                .map((occupation, i) =>
                                <option key={i} value={occupation.Id}>{occupation.Description}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentJobId && touched.PartnerOrParentJobId ? (
                            <FormFeedback>{errors.PartnerOrParentJobId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {values.PartnerOrParentJobId == '12' ?
                    <Col md="3">
                        <FormGroup>
                            <Label>Pekerjaan Lainnya</Label>
                            <Input tag={Field} type="text" name="PartnerOrParentJobOthers" maxLength="30" bsSize="sm"
                                disabled={values.PartnerOrParentJobId !== "12"}
                                invalid={errors.PartnerOrParentJobOthers && touched.PartnerOrParentJobOthers} />
                            {errors.PartnerOrParentJobOthers && touched.PartnerOrParentJobOthers ? (
                                <FormFeedback>{errors.PartnerOrParentJobOthers}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col> : null}
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Posisi</Label>
                        <Field component="select" name="PartnerOrParentPositionId"
                            className={errors.PartnerOrParentPositionId && touched.PartnerOrParentPositionId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onPositionChange(e, values.OccupationId, setFieldValue, values)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.partnerOrParentPositions.sort((a, b) => b.Id - a.Id).map((position, i) =>
                                <option key={i} value={position.Id}>{position.Description}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentPositionId && touched.PartnerOrParentPositionId ? (
                            <FormFeedback>{errors.PartnerOrParentPositionId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {values.PartnerOrParentPositionId == '41' ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Posisi Lainnya</Label>
                            <Input tag={Field} type="text" name="PartnerOrParentPosition" maxLength="30" bsSize="sm"
                                invalid={errors.PartnerOrParentPosition && touched.PartnerOrParentPosition} />
                            {errors.PartnerOrParentPosition && touched.PartnerOrParentPosition ? (
                                <FormFeedback>{errors.PartnerOrParentPosition}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
                <Col md="4">
                    <FormGroup>
                        <Label>Bidang Usaha</Label>
                        <Field component="select" name="PartnerOrParentBusinessFieldId"
                            className={errors.PartnerOrParentBusinessFieldId && touched.PartnerOrParentBusinessFieldId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onBusinessFieldChange(e, setFieldValue, values)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.partnerOrParentBusinessFields.sort((a, b) => b.Id - a.Id).map((businessField, i) =>
                                <option key={i} value={businessField.Id}>{businessField.Description}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentBusinessFieldId && touched.PartnerOrParentBusinessFieldId ? (
                            <FormFeedback>{errors.PartnerOrParentBusinessFieldId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {(values.PartnerOrParentBusinessFieldId == "25") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Bidang Usaha Lainnya</Label>
                            <Input tag={Field} type="text" name="PartnerOrParentBusinessField" maxLength="30" bsSize="sm"
                                invalid={errors.PartnerOrParentBusinessField && touched.PartnerOrParentBusinessField} />
                            {errors.PartnerOrParentBusinessField && touched.PartnerOrParentBusinessField ? (
                                <FormFeedback>{errors.PartnerOrParentBusinessField}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col> : null}
                <Col md="6">
                    <FormGroup>
                        <Label>Nama Perusahaan/Kantor</Label>
                        <Input tag={Field} type="text" name="PartnerOrParentCompanyName" maxLength="30" bsSize="sm"
                            invalid={errors.PartnerOrParentCompanyName && touched.PartnerOrParentCompanyName} />
                        {errors.PartnerOrParentCompanyName && touched.PartnerOrParentCompanyName ? (
                            <FormFeedback>{errors.PartnerOrParentCompanyName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat Perusahaan / Kantor</Label>
                        <Input tag={Field} type="text" name="PartnerOrParentCompanyAddressLine" maxLength="30" bsSize="sm"
                            invalid={errors.PartnerOrParentCompanyAddressLine && touched.PartnerOrParentCompanyAddressLine} />
                        {errors.PartnerOrParentCompanyAddressLine && touched.PartnerOrParentCompanyAddressLine ? (
                            <FormFeedback>{errors.PartnerOrParentCompanyAddressLine}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="6" xs="8">
                    <Label>Kota</Label>
                    <Input tag={Field} type="text" name="PartnerOrParentCompanyAddressCity" maxLength="30" bsSize="sm"
                        invalid={errors.PartnerOrParentCompanyAddressCity && touched.PartnerOrParentCompanyAddressCity} />
                    {errors.PartnerOrParentCompanyAddressCity && touched.PartnerOrParentCompanyAddressCity ? (
                        <FormFeedback>{errors.PartnerOrParentCompanyAddressCity}</FormFeedback>
                    ) : null}
                </Col>
                <Col md="2" xs="4">
                    <FormGroup>
                        <Label>Kode Pos</Label>
                        <Input tag={Field} type="number" name="PartnerOrParentCompanyAddressPostalCode" maxLength="5" bsSize="sm"
                            invalid={errors.PartnerOrParentCompanyAddressPostalCode && touched.PartnerOrParentCompanyAddressPostalCode} />
                        {errors.PartnerOrParentCompanyAddressPostalCode && touched.PartnerOrParentCompanyAddressPostalCode ? (
                            <FormFeedback>{errors.PartnerOrParentCompanyAddressPostalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>No. Telp Kantor</Label>
                        <Input tag={Field} type="tel" name="PartnerOrParentCompanyPhoneNumber" bsSize="sm"
                            invalid={errors.PartnerOrParentCompanyPhoneNumber && touched.PartnerOrParentCompanyPhoneNumber} />
                        {errors.PartnerOrParentCompanyPhoneNumber && touched.PartnerOrParentCompanyPhoneNumber ? (
                            <FormFeedback>{errors.PartnerOrParentCompanyPhoneNumber}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Lama Bekerja/Usaha (tahun)</Label>
                        <Input tag={Field} type="number" name="PartnerOrParentLengthOfWork" bsSize="sm"
                            invalid={errors.PartnerOrParentLengthOfWork && touched.PartnerOrParentLengthOfWork} />
                        {errors.PartnerOrParentLengthOfWork && touched.PartnerOrParentLengthOfWork ? (
                            <FormFeedback>{errors.PartnerOrParentLengthOfWork}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>

        </FormGroup>
        <FormGroup tag="fieldset" hidden={!(values.OccupationId === "3" || values.OccupationId === "7")}>
            <legend>Data Keuangan Pasangan / Orang Tua</legend>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Penghasilan Utama / Kotor / Tahun</Label>
                        <Field component="select" name="PartnerOrParentMainIncomeId"
                            className={errors.PartnerOrParentMainIncomeId && touched.PartnerOrParentMainIncomeId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomePerAnnums.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentMainIncomeId && touched.PartnerOrParentMainIncomeId ? (
                            <FormFeedback>{errors.PartnerOrParentMainIncomeId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Sumber Penghasilan Utama</Label>
                        <Field component="select" name="PartnerOrParentMainIncomeSourceId"
                            className={errors.PartnerOrParentMainIncomeSourceId && touched.PartnerOrParentMainIncomeSourceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomeSources.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentMainIncomeSourceId && touched.PartnerOrParentMainIncomeSourceId ? (
                            <FormFeedback>{errors.PartnerOrParentMainIncomeSourceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <Label>Sumber Penghasilan Lainnya</Label>
                    <Input tag={Field} type="string" name="PartnerOrParentMainIncomeSourceOthers" bsSize="sm"
                        invalid={errors.PartnerOrParentMainIncomeSourceOthers && touched.PartnerOrParentMainIncomeSourceOthers} />
                    {errors.PartnerOrParentMainIncomeSourceOthers && touched.PartnerOrParentMainIncomeSourceOthers ? (
                        <FormFeedback>{errors.PartnerOrParentMainIncomeSourceOthers}</FormFeedback>
                    ) : null}
                </Col>
            </Row>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Penghasilan Tambahan / Kotor / Tahun</Label>
                        <Field component="select" name="PartnerOrParentAdditionalIncomeId"
                            className={errors.PartnerOrParentAdditionalIncomeId && touched.PartnerOrParentAdditionalIncomeId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomePerAnnums.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentAdditionalIncomeId && touched.PartnerOrParentAdditionalIncomeId ? (
                            <FormFeedback>{errors.PartnerOrParentAdditionalIncomeId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Sumber Penghasilan Tambahan</Label>
                        <Field component="select" name="PartnerOrParentAdditionalIncomeSourceId"
                            className={errors.PartnerOrParentAdditionalIncomeSourceId && touched.PartnerOrParentAdditionalIncomeSourceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.incomeSources.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentAdditionalIncomeSourceId && touched.PartnerOrParentAdditionalIncomeSourceId ? (
                            <FormFeedback>{errors.PartnerOrParentAdditionalIncomeSourceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <Label>Sumber Tambahan Lainnya</Label>
                    <Input tag={Field} type="tel" name="PartnerOrParentAdditionalIncomeSourceOthers" bsSize="sm"
                        invalid={errors.PartnerOrParentAdditionalIncomeSourceOthers && touched.PartnerOrParentAdditionalIncomeSourceOthers} />
                    {errors.PartnerOrParentAdditionalIncomeSourceOthers && touched.PartnerOrParentAdditionalIncomeSourceOthers ? (
                        <FormFeedback>{errors.PartnerOrParentAdditionalIncomeSourceOthers}</FormFeedback>
                    ) : null}
                </Col>
            </Row>
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>Pengeluaran Per Bulan</Label>
                        <Field component="select" name="PartnerOrParentExpensesPerMonthId"
                            className={errors.PartnerOrParentExpensesPerMonthId && touched.PartnerOrParentExpensesPerMonthId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.expensesPerMonths.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.PartnerOrParentExpensesPerMonthId && touched.PartnerOrParentExpensesPerMonthId ? (
                            <FormFeedback>{errors.PartnerOrParentExpensesPerMonthId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>

        </FormGroup>
        {/* END: Data Pekerjaan */}

        {state.RiskLevel === "High" ?
            <DataTambahan errors={errors} touched={touched} values={values} onHaveAccountsInOtherBank={onHaveAccountsInOtherBank} />
            : null}

    </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/components/Page4Job.js